import mixpanel from "mixpanel-browser";
import { useEffect } from "react";
import { useLocation } from "wouter";

// Initialize Mixpanel with environment-based configuration
const environment = import.meta.env.MODE || "development";
const shouldTrack = environment === "production";

mixpanel.init("67267983e1f52574e09ca376c5b25d22", {
  debug: environment === "dev",
  track_pageview: true,
  persistence: "localStorage",
  ignore_dnt: true,
});

export const useMixpanel = () => {
  const [location] = useLocation();

  useEffect(() => {
    if (!shouldTrack) {
      return;
    }

    // Track page view whenever location changes
    mixpanel.track("Page View", {
      page: location,
      timestamp: new Date().toISOString(),
    });
  }, [location]);

  return mixpanel;
};

export default mixpanel;
